/**
 * Product Size Guide -- unit toggle only.
 *
 * This does no unit math itself: snippets/product-size-guide-table.liquid
 * and snippets/ws-model-measurements.liquid already compute both the inch
 * and cm value for every cell, server-side, in Liquid, and embed them as
 * data-in / data-cm attributes. This script only swaps which of those two
 * pre-computed values is displayed, and toggles the active state on the
 * Inches/CM buttons.
 *
 * Scope: the toggle lives inside the Product Measurements block, but the
 * Size Guide drawer can contain more than one convertible table (Product
 * Measurements and Model Measurements). So the search starts from the
 * whole drawer body, .product-size-chart__body, which makes the single
 * visible toggle drive every table in the drawer at once -- the customer
 * sees one control, not one per table. It falls back to the enclosing
 * .product-size-guide block if that body wrapper isn't present, which
 * preserves the previous behaviour anywhere the drawer markup differs.
 *
 * Still scoped entirely to [data-unit-toggle] /
 * .product-size-guide__table td -- all unique to this feature, so this
 * cannot affect any other toggle, table, or script on the site. Tables
 * without data-in cells (the International Size Guide) are untouched,
 * because size codes aren't quantities that convert.
 */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-unit-toggle] button');
  if (!button) return;

  var wrapper = button.closest('.product-size-chart__body') || button.closest('.product-size-guide');
  if (!wrapper) return;

  var unit = button.getAttribute('data-unit');
  if (!unit) return;

  wrapper.querySelectorAll('[data-unit-toggle] button').forEach(function (btn) {
    btn.classList.toggle('is-active', btn.getAttribute('data-unit') === unit);
  });

  wrapper.querySelectorAll('.product-size-guide__table td[data-in]').forEach(function (cell) {
    var value = unit === 'cm' ? cell.getAttribute('data-cm') : cell.getAttribute('data-in');
    if (value !== null) {
      cell.textContent = value;
    }
  });
});
